export default __webpack_public_path__ + "static/media/warning--steep-ascent--g2.f04136e9.png";